import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EmailToCounterpartySection', {
    vendorEmailSectionText: 'Email to Vendor',
    attachmentsToVendorTitle: 'Attachments to vendor',
    customerEmailSectionText: 'Email to Customer',
    attachmentsToCustomerTitle: 'Attachments to customer',
});
